var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconeRowLeftWhiteFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.97 45.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f3f5eb;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2-2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2-2",
    "data-name": "Calque 1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.15,
    y: 15.58,
    width: 6.72,
    height: 32.96,
    rx: 1.37,
    transform: "translate(-18.71 18.94) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -3.02,
    y: 10.11,
    width: 32.97,
    height: 6.72,
    rx: 1.37,
    transform: "translate(-5.58 13.47) rotate(-45)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeRowLeftWhiteFilled);
export default __webpack_public_path__ + "static/media/icone_row_left_white_filled.1feed152349a283f83db2f435e074ab1.svg";
export { ForwardRef as ReactComponent };